module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/page-content/page-content.component.html
// module id = ../../../../../src/app/page-content/page-content.component.html
// module chunks = main